// {% # RE - Popup Cart Fix %}

    customElements.get("product-form") ||
        customElements.define(
            "product-form",
            class extends HTMLElement {
                constructor() {
                    super(),
                        (this.form = this.querySelector("form")),
                        (this.form.querySelector("[name=id]").disabled = !1),
                        this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
                        (this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer")),
                        (this.submitButton = this.querySelector('[type="submit"]')),
                        document.querySelector("cart-drawer") && this.submitButton.setAttribute("aria-haspopup", "dialog");
                }
                onSubmitHandler(t) {
                    if ((t.preventDefault(), "true" === this.submitButton.getAttribute("aria-disabled"))) return;
                    this.handleErrorMessage(), this.submitButton.setAttribute("aria-disabled", !0), this.submitButton.classList.add("loading"), this.querySelector(".loading-overlay__spinner").classList.remove("hidden");
                    const e = fetchConfig("javascript");
                    (e.headers["X-Requested-With"] = "XMLHttpRequest"), delete e.headers["Content-Type"];
                    const s = new FormData(this.form);
                    this.cart &&
                        (s.append(
                            "sections",
                            this.cart.getSectionsToRender().map((t) => t.id)
                        ),
                        s.append("sections_url", window.location.pathname),
                        this.cart.setActiveElement(document.activeElement)),
                        (e.body = s),
                        fetch(`${routes.cart_add_url}`, e)
                            .then((t) => t.json())
                            .then((t) => {
                                if (t.status) {
                                    this.handleErrorMessage(t.description);
                                    const e = this.submitButton.querySelector(".sold-out-message");
                                    if (!e) return;
                                    return this.submitButton.setAttribute("aria-disabled", !0), this.submitButton.querySelector("span").classList.add("hidden"), e.classList.remove("hidden"), void (this.error = !0);
                                }
                                if (!this.cart) return void (window.location = window.routes.cart_url);
                                this.error = !1;
                                const e = this.closest("quick-add-modal");
                                e
                                    ? (document.body.addEventListener(
                                          "modalClosed",
                                          () => {
                                              setTimeout(() => {
                                                  this.cart.renderContents(t);
                                              });
                                          },
                                          { once: !0 }
                                      ),
                                      e.hide(!0))
                                    : this.cart.renderContents(t);
                            })
                            .catch((t) => {
                                console.error(t);
                            })
                            .finally(() => {
                                this.submitButton.classList.remove("loading"),
                                    this.cart && this.cart.classList.contains("is-empty") && this.cart.classList.remove("is-empty"),
                                    this.error || this.submitButton.removeAttribute("aria-disabled"),
                                    this.querySelector(".loading-overlay__spinner").classList.add("hidden");
                                    document.getElementById("cart-notification").classList.add("animate", "active");
                            });
                }
                handleErrorMessage(t = !1) {
                    (this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper")),
                        this.errorMessageWrapper &&
                            ((this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message")), this.errorMessageWrapper.toggleAttribute("hidden", !t), t && (this.errorMessage.textContent = t));
                }
            }
        );

    // {% # RE - End Popup Cart Fix %}
    
    const productPage = document.querySelector(".product-page"),
        check_stock_btn = productPage?.querySelector(".check-in-store-btn");
    if (check_stock_btn) {
        const t = document.querySelector(".check-in-store-popup"),
            e = check_stock_btn.getAttribute("data-product-id"),
            s = check_stock_btn.getAttribute("data-product-title"),
            r = check_stock_btn.getAttribute("data-option-title"),
            o = document.querySelector(".stores-stocks"),
            i = document.querySelector(".popup-size");
        let a,
            c,
            n,
            d = [];
        check_stock_btn.setAttribute("disabled", "disabled"),
            check_stock_btn.classList.add("check-loading"),
            document.querySelectorAll('[data-options="stock"]').forEach((t) => {
                t.classList.contains("icon-stock") ? (a = t.innerHTML) : t.classList.contains("icon-low-stock") ? (c = t.innerHTML) : t.classList.contains("icon-out-stock") && (n = t.innerHTML);
            }),
            fetch(window.Shopify.routes.root + "a/ps/shopify/product/" + e, { method: "GET", timeout: 0 })
                .then((t) => t.json())
                .then((t) => {
                    const e = t.data.variants;
                    d = t.data.locations;
                    let l = "";
                    (l += `<p>Select ${r}:</p>`),
                        Object.keys(e).forEach((t, r) => {
                            const o = e[t].displayName,
                                i = Object.keys(e).length > 1 ? o.replace(s + " - ", "") : "One Size";
                            l += `<div class="variant-size-btn ${0 === r ? "active" : ""}" data-variant-id="${t}">${i}</div>`;
                        }),
                        (i.innerHTML = l);
                    let u = "";
                    d.forEach((t, e) => {
                        t.isShow &&
                            ((u += `<div class="store ${d.length === e + 1 ? "no-border" : ""}">\n                <div class="store-detail">\n                  <a href="/pages/store-locator">${t.displayName}</a>\n                </div>`),
                            Object.keys(t.inventories).forEach((e, s) => {
                                (u += `<div data-variant-id="${e}" class="${0 === s ? "show" : ""}">`), t.inventories[e].includes("Not") ? (u += `${n}`) : t.inventories[e].includes("Low") ? (u += `${c}`) : (u += `${a}`), (u += "</div>");
                            }),
                            (u += "</div>"));
                    }),
                        (o.innerHTML = u),
                        check_stock_btn.removeAttribute("disabled"),
                        check_stock_btn.classList.remove("check-loading");
                }),
            check_stock_btn.addEventListener("click", () => {
                if (t) {
                    let e = t.outerHTML;
                    Swal.fire({ html: e, showConfirmButton: !1, allowOutsideClick: !0, showCloseButton: !0 }),
                        document.querySelectorAll(".variant-size-btn").forEach((t) => {
                            t.addEventListener("click", () => {
                                [].forEach.call(document.querySelectorAll(".variant-size-btn"), function (t) {
                                    t.classList.remove("active");
                                }),
                                    t.classList.add("active");
                                const e = t.getAttribute("data-variant-id");
                                [].forEach.call(document.querySelectorAll("[data-variant-id]"), function (t) {
                                    t.classList.remove("show");
                                }),
                                    [].forEach.call(document.querySelectorAll(`[data-variant-id="${e}"]`), function (t) {
                                        t.classList.add("show");
                                    });
                            });
                        });
                }
            });
    }
    